import React, { useEffect } from 'react';
import styles from './procedimentos_drakaisanauroski_.module.scss';
import { Link } from 'react-router-dom';
import Perfil from './src/perfil.png';
import { FaArrowLeft, FaWhatsapp, FaInstagram, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import { motion } from "framer-motion";
const Procedimentos_drakaisanauroski_: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const texto = [
        "Paranaense, nascida em Roncador e atualmente morando em Barretos, São Paulo. <br /> Sou médica formada pela Universidad del Pacífico, com diploma revalidado pela Universidade Estadual de Londrina - PR, e pós-graduada em Medicina Estética pela ISBRAE, com diversas especializações na área da estética.",
        "Minha clínica é a realização de um grande sonho — e também o lugar onde ajudo outras pessoas a realizarem os seus. <br /> Ela é a minha paixão: um espaço onde elevo a autoestima, transformo vidas e acolho muito além das queixas físicas.",
        "Aqui, escuto com atenção, respeito as particularidades de cada paciente e ofereço um cuidado verdadeiramente humanizado. <br /> Meu compromisso vai muito além dos procedimentos: trabalho para que você se sinta valorizada, confiante e plena na sua própria pele.",
    ];

    const procedimentos = [
        "Harmonização facial com ácido hialurônico",
        "Toxina Botulínica (Face, Pescoço, Hiperidrose, Enxaqueca e Hipertrofia de masseter)",
        "Blefaroplastia cirúrgica",
        "Lifting de supercílio cirúrgica",
        "Otoplastia fechada e cirúrgica",
        "Lobuloplastia química",
        "Peeling superficiais, médios e profundos",
        "Subcisão de celulite",
        "Bioestimuladores de colágeno facial e corporal",
        "MMP (microinfusão de medicamentos)",
        "Emptiers para gordura localizada"
    ];
    return (
        <div className={styles.procedimentos_drakaisanauroski_}>
            {/* <div className={styles.header_procedimentos_drakaisanauroski_}>
                <Link to="/drakaisanauroski_" className={styles.backButton} aria-label="Voltar">
                    <FaArrowLeft />
                </Link>
            </div> */}

            <main className={styles.mainContent}>
                <div className={styles.apresentacao}>
                    <img
                        src={Perfil}
                        alt="Dra. Kaisa Nauroski"
                        className={styles.foto}
                    />
                    <div className={styles.textoApresentacao}>
                        <h1>Dra. Kaisa Nauroski</h1>
                        {texto.map((frase, index) => (
                            <motion.p
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.3, duration: 0.6 }}
                                className={styles.paragrafo}
                                dangerouslySetInnerHTML={{ __html: frase }}
                            />
                        ))}

                        <a
                            href="https://wa.me/5517996776711?text=Olá, gostaria de agendar um horário."
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.btnContato}
                            aria-label="Entrar em contato via WhatsApp"
                        >
                            <FaWhatsapp className={styles.iconWhatsapp} />
                            Fale comigo no WhatsApp
                        </a>
                    </div>
                </div>

                <div className={styles.procedimentos}>
                    <h3>Procedimentos realizados</h3>
                    <ul>
                        {procedimentos.map((item, index) => (
                            <motion.li
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1, duration: 0.5 }}
                                viewport={{ once: true }}
                            >
                                {item}
                            </motion.li>
                        ))}
                    </ul>
                </div>
            </main>

            <div className={styles.footer}>
                <div className={styles.contactInfo}>
                    <div className={styles.contactItem}>
                        <FaPhoneAlt className={styles.iconDourado} />
                        (17) 99677-6711
                    </div>
                    <div className={styles.contactItem}>
                        <FaMapMarkerAlt className={styles.iconDourado} />
                        R. Dezesseis, 1309 - Centro, Barretos - SP
                    </div>
                </div>

                <div className={styles.social}>
                    <a href="https://www.instagram.com/drakaisanauroski_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <FaInstagram className={styles.iconDourado} />
                    </a>
                    <a href="https://wa.me/5517996776711?text=Olá, gostaria de agendar um horário." target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                        <FaWhatsapp className={styles.iconDourado} />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/X9jYEoWfKZ4yt7di9"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Localização"
                    >
                        <FaMapMarkerAlt className={styles.iconDourado} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Procedimentos_drakaisanauroski_;
